/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";

export const COMPANY_POSTING_PERIOD_COLUMNS = [
  {
    Header: "Open",
    id: "Open",
    Cell: ({ row }) => (
      <div className="posting-cell">
        <div className={row.original.Open ? "success" : "danger"}>
          {row.original.Open ? "Open" : "Closed"}
        </div>
      </div>
    ),
    maxWidth: "10%",
    sortType: (a, b) => {
      const aValue = a.original.Open;
      const bValue = b.original.Open;
      if (aValue) return -1;
      if (bValue) return 1;
      return 0;
    }
  },
  {
    Header: "Period End Date",
    accessor: "PeriodEndDateTime",
    id: "PeriodEndDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null,
    maxWidth: "10%"
  },
  {
    Header: "Module",
    accessor: "Module.CodeDescription",
    id: "Module",
    maxWidth: "50%"
  }
];
